module.exports = __webpack_public_path__ + "img/trash.8000c344.svg";